import { connectRouter } from "connected-react-router";
import { createBrowserHistory as createHistory } from "history";
import { combineReducers } from "redux";
import warningModalReducer from "./warningModalReducer";
import loaderReducer from "./loaderReducer";
import homeDataReducer from "./homeDataReducer";
import userDataReducer from "./userDataReducer";
import abstractDataReducer from "./abstractDataReducer";

const history = createHistory();

const rootReducer = combineReducers({
  homeDataReducer,
  userDataReducer,
  abstractDataReducer,
  warningModalReducer,
  loaderReducer,
  router: connectRouter(history)
});

export default rootReducer;
